import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ChangePasswordForm = () => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) { toast.error("A nova password deve ter pelo menos 8 caracteres."); return; }
    if (f.new_password !== f.confirm) { toast.error("As passwords não coincidem."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password alterada com sucesso.");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <form onSubmit={submit} data-testid="change-password-form" className="space-y-4">
      <div className="space-y-2"><Label className="sc-label">Password atual</Label><Input data-testid="cp-current" type="password" required value={f.current_password} onChange={set("current_password")} className="sc-cpi" /></div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-2"><Label className="sc-label">Nova password</Label><Input data-testid="cp-new" type="password" required value={f.new_password} onChange={set("new_password")} className="sc-cpi" /></div>
        <div className="space-y-2"><Label className="sc-label">Confirmar nova password</Label><Input data-testid="cp-confirm" type="password" required value={f.confirm} onChange={set("confirm")} className="sc-cpi" /></div>
      </div>
      <button type="submit" disabled={saving} data-testid="cp-submit" className="bg-[#48020C] hover:bg-[#26130E] text-[#FCFCFA] rounded-full px-8 py-3 transition-colors">{saving ? "A alterar…" : "Alterar password"}</button>
      <style>{`.sc-cpi{background:#FCFCFA;border-color:#E3DED2;border-radius:0.6rem;height:auto;padding:0.65rem 0.85rem;}`}</style>
    </form>
  );
};
